import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
import { contextConnect, useContextSystem } from '@wp-g2/context';
import { css, cx } from '@wp-g2/styles';
import React from 'react';
import { View } from '../View';
import * as styles from './Placeholder.styles';

function Placeholder(props, forwardedRef) {
  var _useContextSystem = useContextSystem(props, 'Placeholder'),
      className = _useContextSystem.className,
      _useContextSystem$hei = _useContextSystem.height,
      height = _useContextSystem$hei === void 0 ? 36 : _useContextSystem$hei,
      width = _useContextSystem.width,
      otherProps = _objectWithoutProperties(_useContextSystem, ["className", "height", "width"]);

  var classes = cx(styles.Placeholder, css({
    width: width,
    height: height
  }), className);
  return /*#__PURE__*/React.createElement(View, Object.assign({
    className: classes
  }, otherProps, {
    ref: forwardedRef
  }));
}

export default contextConnect(Placeholder, 'Placeholder');